module.exports = "<app-header></app-header>\r\n<div class=\"container\" *ngIf=\"isToken\">\r\n    <div class=\"content-wrapper\">\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>\r\n<div *ngIf=\"!isToken\">\r\n    <!-- <div class=\"content-wrapper\"> -->\r\n    <app-callbacks></app-callbacks>\r\n    <!-- </div> -->\r\n</div>\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-app/opc.component.html
// module id = ./src/opc/opc-app/opc.component.html
// module chunks = main